import React from "react";
import { observer } from "mobx-react";

import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";

import { ErrorWrapper } from "@features/offer/shared/statistics";
import { GroupedPlayerStats } from "@features/offer/mobile/statistics";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";

export default observer(function LivePlayerStatistics(props: {
	isSettingsDrawerOpen: boolean;
	onClose: (value: boolean) => void;
}) {
	const store = useOfferContext<OfferStore.EventViewStore>();

	if (store.displayStatisticsGroup === StatisticsGroups.PlayerStats) {
		return (
			<ErrorWrapper>
				<GroupedPlayerStats
					isSettingsDrawerOpen={props.isSettingsDrawerOpen}
					onClose={props.onClose}
					store={store.playerStatisticsStore}
				/>
			</ErrorWrapper>
		);
	}

	return null;
});
